




























import { computed, defineComponent } from "@vue/composition-api";
import { isAudioFile } from "@/lib/fileHelpers";
import { MediaFilesController } from "@/lib/MediaFilesController";
import { getMediaDuration } from "@/lib/time";
import { UploadVaultFile } from "@/types";
import BaseIcon from "@/components/BaseIcon";

export default defineComponent({
  name: "VaultFileItemWithoutPreview",
  components: {
    BaseIcon,
  },
  props: {
    isLoading: { type: Boolean, default: false },
    thumbnails: { type: Boolean, default: false },
    fileClasses: { type: Array as () => Record<string, string>[] },
    file: { type: Object as () => UploadVaultFile, required: true },
  },
  setup(props) {
    const getDuration = computed<string | null>(() =>
      props.file.metadata.duration ? getMediaDuration(Number(props.file.metadata.duration)) : null
    );
    const text = computed(() => props.file.metadata.filename);
    const isAnAudioFile = computed<boolean>(() => isAudioFile(props.file));
    const icon = computed(() => (isAnAudioFile.value ? "sci-music-note" : "sci-file-outline"));
    const url = computed(() => MediaFilesController.getFileUrl(props.file.urlPart));

    const goToFile = () => {
      window.open(url.value, "_blank");
    };
    return {
      getDuration,
      text,
      icon,
      url,
      goToFile,
    };
  },
});
